import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import Subheader from "material-ui/Subheader";
import Divider from "material-ui/Divider";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";

import {
  CheckBox,
  IconButton,
  Loadable,
  Page,
  StyledButton,
  TextField,
  SelectField,
  If
} from "components/support";
import { PaymentOthers } from "core/enum";

import style from "./style";
import { colors } from "assets";

class PaymentsView extends Component {
  render() {
    const { className, presenter, viewModel } = this.props;
    const { title, loading, payments, errors } = viewModel;

    return (
      <div className={`${className} grid-container`}>
        <Page>
          <Typography type="display1" className="pb-sm">
            {title}
          </Typography>
          <Loadable loading={loading}>
            <Paper elevation={1}>
              <Subheader>
                As formas de pagamento cadastradas serão apresentadas na opção
                "Outros" no aplicativo.
              </Subheader>
              <Subheader style={{ lineHeight: 0, marginBottom: 25 }}>
                Os campos marcados com * são obrigatórios.
              </Subheader>

              <Divider />

              <Row className="ml-sm">
                <Col xs={12} sm={2}>
                  <Row center="xs">
                    <Col
                      xs={12}
                      className="create-payment"
                      onClick={() => presenter.handleNewPayment()}
                    >
                      <Typography type="subheading" className="pb-sm">
                        Adicionar uma nova opção
                      </Typography>
                      <IconButton
                        mini
                        icon="add"
                        iconStyle={{ color: `${colors.secondary.dark}` }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={10}>
                  <Row>
                    {payments.map((payment, i) => (
                      <Col
                        key={payment.uuid}
                        xs
                        lg={12}
                        style={{ display: "inline-block" }}
                        className="full-width"
                      >
                        <Row className="m-0 full-width" top="xs">
                          <Col xs={12} lg={4} className={`mt-0 mb-sm mr-sm`}>
                            <TextField
                              fullWidth
                              underlineShow={false}
                              value={payment.label}
                              maxLength={15}
                              floatingLabelFixed
                              floatingLabelText="Descrição*"
                              onChange={(_, value) =>
                                presenter.onChange(i, "label", value)
                              }
                              errorText={errors[i] ? errors[i].label : ""}
                            />
                          </Col>

                          <Col xs={12} lg={3} className={`mt-0 mb-sm mr-sm`}>
                            <SelectField
                              floatingLabelFixed
                              floatingLabelText="Tipo de Pagamento*"
                              value={payment.payment_type}
                              onChange={(_, value) =>
                                presenter.onChange(i, "payment_type", value)
                              }
                              fullWidth
                              options={PaymentOthers}
                              errorText={errors[i] ? errors[i].type : ""}
                            />
                          </Col>

                          <Col xs={12} lg={2} className={`mt-0 mb-sm mr-sm`}>
                            <Row bottom="xs">
                              <Col xs={10}>
                                <CheckBox
                                  style={{ paddingTop: 16 }}
                                  checkBoxStyle={{ marginTop: 16 }}
                                  labelStyle={{ textAlign: "center" }}
                                  checked={payment.use_note}
                                  label="Informação adicional"
                                  onCheck={checked =>
                                    presenter.onChange(i, "use_note", checked)
                                  }
                                />
                              </Col>
                              <Col
                                xs={2}
                                className="mb-sm"
                                style={{ paddingLeft: 0 }}
                              >
                                <Tooltip
                                  id={`tooltip-top-${i}`}
                                  title={
                                    <span className="title-tooltip">
                                      Toda forma de pagamento com o tipo
                                      cadastrado selecionado poderá ter uma
                                      informação adicional ao ser utilizado como
                                      forma de pagamento no aplicativo.
                                    </span>
                                  }
                                  placement="top"
                                >
                                  <Icon className="tooltip-icon">info</Icon>
                                </Tooltip>
                              </Col>
                            </Row>
                          </Col>

                          <Col xs={12} lg={1} className={`mt-0 mb-sm mr-sm`}>
                            <CheckBox
                              style={{ paddingTop: 32 }}
                              checked={payment.enabled}
                              label="Ativo"
                              onCheck={checked =>
                                presenter.onChange(i, "enabled", checked)
                              }
                            />
                          </Col>

                          <If test={payment.createdNow}>
                            <Col
                              xs={12}
                              lg={1}
                              className={`mt-0 mb-sm mr-sm delete-payment`}
                            >
                              <IconButton
                                mini
                                icon="delete"
                                onClick={() => presenter.onDeletePayment(i)}
                              />
                            </Col>
                          </If>
                        </Row>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>

              <div className="text-right p-sm">
                <StyledButton
                  label="Salvar Pagamentos"
                  primary={true}
                  onTouchTap={() => presenter.onSendForm()}
                />
              </div>
            </Paper>
          </Loadable>
        </Page>
      </div>
    );
  }
}

export default style(PaymentsView);



// WEBPACK FOOTER //
// ./src/components/app/registration/payment/view.jsx